// data to be consumed by our test/ci environment
export default { // Groups in Dashsboard
  Groups: [
    {
      created_at: "2018-05-11 13:22:39",
      creator_id: 1,
      deleted_at: null,
      description: "A group for schools",
      group_type_id: 1,
      id: 1,
      name: "School Group",
      public: true,
      updated_at: "2018-05-11 13:22:39"
    },
    {
      created_at: "2018-05-14 1:22:39",
      creator_id: 1,
      deleted_at: null,
      description: "A group for districts",
      group_type_id: 1,
      id: 2,
      name: "District Group",
      public: true,
      updated_at: "2018-05-14 1:22:39"
    }
  ],
  // Group Members
  GroupMembers: [
    {
      "id": 1,
      "first_name": "Amaze",
      "last_name": "Administrator",
      "display_name": "Amaze Administrator",
      "email": "amaze@rti.org",
      "created_at": null,
      "updated_at": "2018-05-16 16:55:11",
      "deleted_at": null,
      "last_login": "2018-05-16 16:55:11",
      "status": true,
      "reset_password": false,
      "terms": true,
      "school_id": 1,
      "district_id": 1,
      "organization_id": 1,
      "profile_photo": [],
      "pivot": {
        "group_id": 1,
        "user_id": 1
      }
    },
    {
      "id": 2,
      "first_name": "Miles",
      "last_name": "Fink",
      "display_name": "Miles Fink",
      "email": "mfink@rti.org",
      "created_at": null,
      "updated_at": "2018-05-16 17:55:11",
      "deleted_at": null,
      "last_login": "2018-05-16 17:55:11",
      "status": true,
      "reset_password": false,
      "terms": true,
      "school_id": 1,
      "district_id": 1,
      "organization_id": 1,
      "profile_photo": [],
      "pivot": {
        "group_id": 1,
        "user_id": 2
      }
    }
  ],
  // User Profile
  Profile: {
    "id": 1,
    "first_name": "Amaze",
    "last_name": "Administrator",
    "display_name": "Amaze Administrator",
    "email": "amaze@rti.org",
    "created_at": null,
    "updated_at": "2018-05-16 16:55:11",
    "deleted_at": null,
    "last_login": "2018-05-16 16:55:11",
    "status": true,
    "reset_password": false,
    "terms": true,
    "school_id": 1,
    "district_id": 1,
    "organization_id": 1,
    "profile_photo": [],
    "district": {
      "id": 1,
      "name": "Demonstration District",
      "cds_code": "9999999999",
      "nces_code": "9999999999",
      "address1": "123 Main St.",
      "address2": "",
      "city": "Seattle",
      "state_id": 56,
      "zip": "98126",
      "status": true,
      "created_at": null,
      "updated_at": null,
      "deleted_at": null
    },
    "school": {
      "id": 1,
      "name": "Demonstration School",
      "cds_code": "9999999999",
      "nces_code": "9999999999",
      "address1": "123 Main St.",
      "address2": "",
      "city": "Seattle",
      "state_id": 56,
      "zip": "98126",
      "status": true,
      "district_id": 1,
      "created_at": null,
      "updated_at": null,
      "deleted_at": null
    },
    "flags": [
      {
        "id": 1,
        "name": "uber_admin",
        "friendly_name": "Uber-Admin",
        "pivot": {
          "user_id": 1,
          "flag_id": 1
        }
      }
    ]
  },
  // alternate Profile for impersonating
  ImpersonateProfile: {
    "id": 2,
    "first_name": "Amaze",
    "last_name": "Teacher",
    "display_name": "Amaze Teacher",
    "email": "teacher@rti.org",
    "created_at": null,
    "updated_at": null,
    "deleted_at": null,
    "last_login": null,
    "status": true,
    "reset_password": false,
    "terms": true,
    "school_id": 1,
    "district_id": 1,
    "organization_id": 1,
    "profile_photo": [],
    "district": {
      "id": 1,
      "name": "Demonstration District",
      "cds_code": "9999999999",
      "nces_code": "9999999999",
      "address1": "123 Main St.",
      "address2": "",
      "city": "Seattle",
      "state_id": 56,
      "zip": "98126",
      "status": true,
      "created_at": null,
      "updated_at": null,
      "deleted_at": null
    },
    "school": {
      "id": 1,
      "name": "Demonstration School",
      "cds_code": "9999999999",
      "nces_code": "9999999999",
      "address1": "123 Main St.",
      "address2": "",
      "city": "Seattle",
      "state_id": 56,
      "zip": "98126",
      "status": true,
      "district_id": 1,
      "created_at": null,
      "updated_at": null,
      "deleted_at": null
    },
    "flags": [
      {
        "id": 3,
        "name": "teacher",
        "friendly_name": "Teacher",
        "pivot": {
          "user_id": 2,
          "flag_id": 3
        }
      }
    ]
  }
}
